import { budgetCurrencyFormat } from "@/other/utils/budgetUtils";
import { TASK_BUDGET_FIELDS } from "@/other/constants/OtherKeys";
import type { TaskBudget } from "@/bryntum-lib/models/TaskBudget";

export interface UserPreferences {
  updateSetting: (key: string, value: string, isBoardPref?: boolean) => void;
  getSetting: (key: string, defaultValue?: string, isBoardPref?: boolean) => string | undefined;
}

export interface BudgetViewProps {
  budget: TaskBudget;
  userPreferences: UserPreferences | null;
}

export interface CostCategory {
  label: string;
  est: string;
  act: string;
  var: string;
  color: string;
}

export const COST_CATEGORIES: CostCategory[] = [
  { label: "Labor", est: TASK_BUDGET_FIELDS.laborEstimated, act: TASK_BUDGET_FIELDS.laborActual, var: TASK_BUDGET_FIELDS.laborVariance, color: "hsl(var(--chart-1))" },
  { label: "Materials", est: TASK_BUDGET_FIELDS.materialsEstimated, act: TASK_BUDGET_FIELDS.materialsActual, var: TASK_BUDGET_FIELDS.materialsVariance, color: "hsl(var(--chart-2))" },
  { label: "Subs", est: TASK_BUDGET_FIELDS.subsEstimated, act: TASK_BUDGET_FIELDS.subsActual, var: TASK_BUDGET_FIELDS.subsVariance, color: "hsl(var(--chart-3))" },
  { label: "Rentals", est: TASK_BUDGET_FIELDS.rentalsEstimated, act: TASK_BUDGET_FIELDS.rentalsActual, var: TASK_BUDGET_FIELDS.rentalsVariance, color: "hsl(var(--chart-4))" },
  { label: "Misc", est: TASK_BUDGET_FIELDS.miscellaneousEstimated, act: TASK_BUDGET_FIELDS.miscellaneousActual, var: TASK_BUDGET_FIELDS.miscellaneousVariance, color: "hsl(var(--chart-5))" },
];

export function formatCurrency(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value)) return "N/A";
  return budgetCurrencyFormat.format(value);
}

export function formatCompactCurrency(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value)) return "N/A";
  const abs = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}m`;
  if (abs >= 1_000) return `${sign}$${(abs / 1_000).toFixed(abs >= 10_000 ? 0 : 1)}k`;
  return `${sign}$${abs.toFixed(0)}`;
}

export function formatPercent(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value)) return "N/A";
  return `${value}%`;
}

export function getVarianceColor(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value) || value === 0) return "";
  return value > 0
    ? "text-green-600 dark:text-green-500"
    : "text-red-600 dark:text-red-400";
}
